import {setContext} from '@apollo/client/link/context';

import {BUILD_HEADER} from 'resources/mandark.resource';

const authLink = setContext((_, {headers}) => {
  return {
    headers: {
      ...headers,
      ...BUILD_HEADER()
    }
  };
});

export default authLink;
